module.exports = __webpack_public_path__ + "static/media/pinYellow.f0ebed98.svg";